const runIdToQueueKey = new Map<string, string>();

/** Clears in-memory dispatch bookkeeping (Vitest only). */
export function resetPromptQueueRunnerStateForTests(): void {
  runIdToQueueKey.clear();
}

export function getRunIdQueueKey(runId: string): string | undefined {
  return runIdToQueueKey.get(runId);
}

export function setRunIdQueueKey(runId: string, queueKey: string): void {
  runIdToQueueKey.set(runId, queueKey);
}

export function deleteRunIdQueueKey(runId: string): string | undefined {
  const queueKey = runIdToQueueKey.get(runId);
  runIdToQueueKey.delete(runId);
  return queueKey;
}

export function syncRunningTurnQueueKeys(
  turns: Array<{ turnId: string; lastCliState: string | null }>,
  queueKey: string,
): void {
  for (const running of turns.filter((t) => t.lastCliState === 'running')) {
    runIdToQueueKey.set(running.turnId, queueKey);
  }
}
